import React, { useState } from 'react'
import {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  StyleSheet,
  ScrollView
} from 'react-native'
import { Entypo, AntDesign, Ionicons } from '@expo/vector-icons'
import { colorPalette, globalStyles } from '../../static/styles/global'
import CardSeparator from '../../components/shared/card/CardSeparator'
import CustomButton from '../../components/shared/button/Button'
import Card from '../../components/shared/card/Card'

const DepartmentMessages = ({ navigation }): JSX.Element => {
  const updatesData = [
    {
      heading: 'Holiday Schedule',
      update:
        'we have overtime available if anyone would like to pick up shift or two ',
      time: '12:20 pm'
    },
    {
      heading: 'New Schedule',
      update: '8:30 pm schedule is available for working',
      time: '1:40 pm'
    },
    {
      heading: 'leave',
      update: 'hi this is the new update',
      time: '1:20 pm'
    },
    {
      heading: 'New Shift',
      update:
        'we have overtime available if anyone would like to pick up shift or two in the group',
      time: '8:20 pm'
    }
  ]

  const handelNewMessage = () => {
    navigation.navigate('MessageNew', {})
  }
  const [searchText, setSearchText] = useState('')
  const [filteredData, setFilteredData] = useState(updatesData)

  const handleSearch = (text) => {
    setSearchText(text)

    const filteredData = updatesData.filter(
      (item) =>
        item.heading.toLowerCase().includes(text.toLowerCase()) ||
        item.time.includes(text) ||
        item.update.toLowerCase().includes(text.toLowerCase())
    )

    setFilteredData(filteredData)
  }

  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View
          style={[
            globalStyles.hDirection,
            globalStyles.vCenterItems,
            globalStyles.hBetweenItems,
            globalStyles.mb3
          ]}
        >
          <TouchableOpacity
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.flexOne
            ]}
            onPress={() => {
              navigation.navigate('Messages')
            }}
          >
            <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
              <Ionicons
                name="chevron-back"
                size={24}
                color={colorPalette.white}
              />
            </View>

            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              {'Messages'}
            </Text>
          </TouchableOpacity>
        </View>
        <View style={{ marginTop: 20, marginBottom: 0 }}>
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: 24
            }}
          >
            Department messages
          </Text>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View>
            <TextInput
              style={[globalStyles.searchInput]}
              placeholder="Search"
              value={searchText}
              onChangeText={handleSearch}
            />
          </View>
          <View>
            <Text style={styles.heading}>Messages</Text>
            {filteredData.map((item, index) => (
              <View key={index}>
                <View style={{ marginTop: 20 }}>
                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate('CommunicationwithDepartment')
                    }
                  >
                    <View
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Text style={{ fontSize: 12, fontWeight: 'bold' }}>
                        {item.heading}
                      </Text>

                      <View
                        style={{
                          flexDirection: 'row'
                        }}
                      >
                        <Text>{item.time}</Text>
                        <AntDesign
                          name="delete"
                          size={28}
                          style={{ color: 'black', right: 0, marginLeft: 20 }}
                        />
                      </View>
                    </View>
                    <View style={{ marginRight: 10 }}>
                      <Text numberOfLines={2} style={{ width: 150 }}>
                        {item.update}
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View>
                <CardSeparator />
              </View>
            ))}
          </View>
          <CustomButton
            text={'Create New Message'}
            onPress={handelNewMessage}
          />
        </Card>
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  heading: {
    fontWeight: 'bold',
    paddingVertical: 10,
    color: '#0B495C'
  }
})
export default DepartmentMessages
